/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DirectoryGroup,
  GroupsListParams
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary List groups (public)
 */
export const groupsList = (
    params?: GroupsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DirectoryGroup[]>(
      {url: `/api/groups`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGroupsListQueryKey = (params?: GroupsListParams,) => {
    return [
    `/api/groups`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGroupsListQueryOptions = <TData = Awaited<ReturnType<typeof groupsList>>, TError = unknown>(params?: GroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupsList>>> = ({ signal }) => groupsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GroupsListQueryResult = NonNullable<Awaited<ReturnType<typeof groupsList>>>
export type GroupsListQueryError = unknown


export function useGroupsList<TData = Awaited<ReturnType<typeof groupsList>>, TError = unknown>(
 params: undefined |  GroupsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupsList>>,
          TError,
          Awaited<ReturnType<typeof groupsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGroupsList<TData = Awaited<ReturnType<typeof groupsList>>, TError = unknown>(
 params?: GroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupsList>>,
          TError,
          Awaited<ReturnType<typeof groupsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGroupsList<TData = Awaited<ReturnType<typeof groupsList>>, TError = unknown>(
 params?: GroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List groups (public)
 */

export function useGroupsList<TData = Awaited<ReturnType<typeof groupsList>>, TError = unknown>(
 params?: GroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGroupsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get group (public)
 */
export const groupsGet = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DirectoryGroup>(
      {url: `/api/groups/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGroupsGetQueryKey = (id?: string,) => {
    return [
    `/api/groups/${id}`
    ] as const;
    }

    
export const getGroupsGetQueryOptions = <TData = Awaited<ReturnType<typeof groupsGet>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupsGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupsGet>>> = ({ signal }) => groupsGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GroupsGetQueryResult = NonNullable<Awaited<ReturnType<typeof groupsGet>>>
export type GroupsGetQueryError = unknown


export function useGroupsGet<TData = Awaited<ReturnType<typeof groupsGet>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupsGet>>,
          TError,
          Awaited<ReturnType<typeof groupsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGroupsGet<TData = Awaited<ReturnType<typeof groupsGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupsGet>>,
          TError,
          Awaited<ReturnType<typeof groupsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGroupsGet<TData = Awaited<ReturnType<typeof groupsGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get group (public)
 */

export function useGroupsGet<TData = Awaited<ReturnType<typeof groupsGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGroupsGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




